/**
 * Newcop search - ajustes sobre nc-search.js (se carga despues de el):
 * - Enter con una busqueda SIN productos: no se va a /search; el buscador se queda abierto con
 *   el aviso, las busquedas populares y los recomendados (en movil se cierra el teclado para verlos).
 * - Enter con un termino que coincide exactamente con el titulo de una coleccion con productos
 *   (marca, linea...): va directo a esa coleccion, sin necesidad de darla de alta en las redirecciones.
 * - Sin resultados no se sugieren colecciones ni consultas (suelen ser colecciones vacias).
 * - Fecha de entrega de la ficha de producto (main-product / main-product-v2 la escriben en espanol
 *   con JS inline): en los demas idiomas se reescribe la frase conservando las fechas ya localizadas.
 * - Griego (el): texto del aviso "sin coincidencia exacta" (noExactText de nc-search.js no lo incluye).
 * Los ajustes de maquetacion de /search estan en assets/nc-fixes.css.
 */
(() => {
  const norm = (s) =>
    String(s || '')
      .normalize('NFD')
      .replace(/[^\x00-\x7f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  customElements.whenDefined('nc-search').then((C) => {
    const P = C.prototype;
    if (P.__ncExtra) return;
    P.__ncExtra = true;
    const origGo = P.go;
    const origRender = P.render;
    const origNoExact = P.noExactText;
    P.noExactText = function (q) {
      const lang = (document.documentElement.lang || 'es').toLowerCase().slice(0, 2);
      if (lang !== 'el') return typeof origNoExact === 'function' ? origNoExact.call(this, q) : '';
      const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      return 'Δεν βρήκαμε ακριβή αποτελέσματα για «' + '<strong>' + esc(q) + '</strong>' + '». Σου δείχνουμε παρόμοια.';
    };

    P.render = function (q, data) {
      if (data && data.count === 0 && !(this.redirects[norm(q)] || this.redirects[this.rewrite(q)])) {
        data = Object.assign({}, data, { suggest: '' });
      }
      return origRender.call(this, q, data);
    };

    P.go = async function (term, source) {
      const q = String(term || '').trim();
      if (!q || this.isCode(q) || this.redirects[norm(q)] || this.redirects[this.rewrite(q)]) {
        return origGo.call(this, term, source);
      }
      const key = norm(q);
      let data = this.cache.get(key);
      if (!data) {
        this.input.value = q;
        try {
          await this.search(q);
        } catch (e) {
          /* se sigue con el comportamiento normal */
        }
        data = this.cache.get(key);
      }
      if (!data) return origGo.call(this, term, source);
      if (data.count === 0) {
        this.input.value = q;
        if (this.clearBtn) this.clearBtn.hidden = false;
        if (this.term !== q) this.search(q);
        // movil: cerrar el teclado para que se vean el aviso y los recomendados
        if (window.matchMedia('(max-width: 749px)').matches) this.input.blur();
        return;
      }
      const box = document.createElement('div');
      box.innerHTML = data.suggest || '';
      const rw = norm(this.rewrite(q));
      const hit = Array.from(box.querySelectorAll('[data-nc-group="collections"] a')).find((a) => {
        const t = norm(a.textContent);
        return t === key || t === rw;
      });
      if (hit && hit.getAttribute('href')) {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'nc_search_redirect', search_term: q, search_source: source, redirect_url: hit.getAttribute('href') });
        } catch (e) {
          /* analytics must never break search */
        }
        window.location.href = hit.getAttribute('href');
        return;
      }
      return origGo.call(this, term, source);
    };
  });
})();

// Delivery-date sentence on the product page: sections/main-product(-v2).liquid write
// 'Entrega entre el <strong>…</strong> (Excepto festivos)' in Spanish for every language
// (dates already localized). Rewrite it for the other languages, keeping the dates and the <strong>.
(() => {
  const T = {
    "en": "Delivery between {from} and {to} (excluding public holidays)",
    "fr": "Livraison entre le {from} et le {to} (hors jours fériés)",
    "de": "Lieferung zwischen dem {from} und dem {to} (außer an Feiertagen)",
    "it": "Consegna tra il {from} e il {to} (festivi esclusi)",
    "pt": "Entrega entre {from} e {to} (exceto feriados)",
    "pl": "Dostawa między {from} a {to} (z wyjątkiem świąt)",
    "ca": "Lliurament entre el {from} i el {to} (excepte festius)",
    "nl": "Levering tussen {from} en {to} (behalve op feestdagen)",
    "el": "Παράδοση από {from} έως {to} (εκτός αργιών)",
    "hr": "Dostava između {from} i {to} (osim praznika)"
  };
  const lang = (document.documentElement.lang || 'es').toLowerCase().slice(0, 2);
  const tpl = T[lang];
  if (lang === 'es' || !tpl) return;
  const SEL = '.delivery-date-dynamic, .delivery-date-popup-dynamic, .atc-modal-delivery-date, .atc-modal-delivery-date-popup';
  const RE = /^\s*Entrega\s+entre\s+el\s*<strong([^>]*)>\s*([\s\S]+?)\s+-\s+([\s\S]+?)\s*<\/strong>\s*\(\s*Excepto\s+festivos\s*\)\s*$/i;
  const fix = (el) => {
    const m = RE.exec(el.innerHTML);
    if (!m) return;
    const open = '<strong' + m[1] + '>';
    el.innerHTML = tpl
      .replace('{from}', () => open + m[2] + '</strong>')
      .replace('{to}', () => open + m[3] + '</strong>');
  };
  const run = () => document.querySelectorAll(SEL).forEach(fix);
  const watched = new WeakSet();
  const watch = () => {
    document.querySelectorAll(SEL).forEach((el) => {
      const box = el.parentElement || el;
      if (watched.has(box)) return;
      watched.add(box);
      new MutationObserver(run).observe(box, { childList: true, characterData: true, subtree: true });
    });
  };
  const start = () => {
    run();
    watch();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
})();
